import * as React from "react";

export const Iris = () => {
  return (
    <b>
      <i>Iris</i>
    </b>
  );
};

export const IrisAssessment = () => {
  return (
    <b>
      <i>Iris</i> Assessment
    </b>
  );
};

export const IrisEditor = () => {
  return (
    <b>
      <i>Iris</i> Editor
    </b>
  );
};



// WEBPACK FOOTER //
// ./src/components/Iris.tsx